import { render } from "./F2Download.vue?vue&type=template&id=3c662e84&ts=true"
import script from "./F2Download.vue?vue&type=script&lang=ts"
export * from "./F2Download.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__